import { sellerSlice } from 'v3/data/store/seller';
import { sellerInitialState } from 'v3/data/store/seller/state';
import { ISeller, ISellersList, IStoreList, IUploadSellerFileResponseData } from 'v3/data/store/seller/types';
import { store } from '..';

export const setSeller = (person: ISeller) => {
  store.dispatch(sellerSlice.actions.setSeller(person));
};

export const setSellerId = (sellerId: string) => {
  store.dispatch(sellerSlice.actions.setSellerId(sellerId));
};

export const setRemoveSeller = () => {
  store.dispatch(sellerSlice.actions.setRemoveSeller());
};

export const clearSeller = () => {
  store.dispatch(sellerSlice.actions.clearSeller());
};

export const resetSellerListPagination = () => {
  store.dispatch(sellerSlice.actions.setFilterCurrentPage(sellerInitialState.sellersFilter.page));
  store.dispatch(sellerSlice.actions.setFilterRowsPerPage(sellerInitialState.sellersFilter.rowsPerPage));
};

export const setAllSellerList = (sellers: ISellersList) => {
  store.dispatch(sellerSlice.actions.setAllSellerList(sellers));
};

export const setSellerStoreList = (storeList: IStoreList[]) => {
  store.dispatch(sellerSlice.actions.setStoreList(storeList));
};

export const setSellersFilters = (filter: string) => {
  store.dispatch(sellerSlice.actions.setSellersFilters(filter));
};

export const setSellerActive = (active: boolean | null) => {
  store.dispatch(sellerSlice.actions.setSellerActive(active));
};

export const setFilterCurrentPage = (value: number) => {
  store.dispatch(sellerSlice.actions.setFilterCurrentPage(value));
};

export const setFilterRowsPerPage = (value: number) => {
  store.dispatch(sellerSlice.actions.setFilterRowsPerPage(value));
};

export const clearSellerSelected = () => {
  store.dispatch(sellerSlice.actions.clearSellerSelected());
};

export const setUploadSellerFileResponse = (response: IUploadSellerFileResponseData) => {
  store.dispatch(sellerSlice.actions.setUploadSellerFileResponse(response));
};

export const setSellerStoreIdsListFilter = (storeIdsList: string[]) => {
  store.dispatch(sellerSlice.actions.setStoreIdsList(storeIdsList));
};

export const setSellerInvalidRowsModalOpen = (value: boolean) => {
  store.dispatch(sellerSlice.actions.setSellerInvalidRowsModalOpen(value));
};

export const restoreSellerStoreList = (storeList: IStoreList[]) => {
  const defaultCheckedList = storeList.map((item) => {
    return {
      ...item,
      checked: true,
    };
  });
  const defaultCheckedIdsList = storeList.map((item) => item.id);
  setSellerStoreIdsListFilter(defaultCheckedIdsList);
  setSellerStoreList(defaultCheckedList);
};
